import React from 'react';
import { useSearchSectionLogic } from './useSearchSection.logic';
import AsyncSearchInput from './AsyncSearchInput';
import './SearchSection.styles.scss';
import SearchIcon from 'assets/icons/searchIcon.svg';

interface SearchSectionProps {
  suggestions: Array<{ text: string; searchTerm: string; type?: string; gfc?: string }>;
}

const SearchSection: React.FC<SearchSectionProps> = ({ suggestions }) => {
  const {
    inputValue,
    fetchSearchSuggestions,
    handleSearchSelect,
    handleInputChange,
    handleClearInput,
    handleSearchSubmit,
    handleSuggestionClick,
  } = useSearchSectionLogic();

  return (
    <div className="search-section">
      <div className="search-container">
        <AsyncSearchInput
          inputValue={inputValue}
          onInputChange={(value: string) => {
            handleInputChange(value, { action: 'input-change' });
          }}
          onSelect={handleSearchSelect}
          onClear={handleClearInput}
          loadOptions={fetchSearchSuggestions}
          placeholder="Search molecules or concepts..."
          onKeyDown={(e: React.KeyboardEvent) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleSearchSubmit();
            }
          }}
        />
        <button className="search-btn" aria-label="Search" onClick={handleSearchSubmit}>
          <img className="searchIcon" src={SearchIcon} alt="search icon" />
        </button>
      </div>
      <div className="search-suggestions">
        {suggestions.map((suggestion, index) => (
          <span
            key={index}
            className="suggestion-tag"
            data-search={suggestion.searchTerm}
            tabIndex={0}
            role="button"
            onClick={() => handleSuggestionClick(suggestion)}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleSuggestionClick(suggestion);
              }
            }}
          >
            {suggestion.text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default SearchSection;
